import { useClickToCopyCore } from '../shared/utils/clickToCopyUtils.mjs';

const useClickToCopy = (params)=>{
    return useClickToCopyCore({
        ...params,
        iconSize: 'inherit'
    });
};

export { useClickToCopy };
//# sourceMappingURL=clickToCopyUtils.mjs.map
